<form [formGroup]="form">
  <div class="crud-item-section">
  
    <span>
      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
            formControlName="havs" id="havs" matTooltip="HAVS (Hand Arm Vibration Syndrome)"            
            (ngModelChange)="havsChanging($event)" [(ngModel)]="item.havs"              
            (ngModelChange)="havsChanged($event)" #havs i18n="@@type.MechanicalAspect.havs">
HAVS          </mat-slide-toggle>        
      </span>
    </span>

    <span>
      <mat-form-field matTooltip="Select a Hand Arm Vibration Syndrom (HAVS) Red/Amber/Green Status from the list" [matTooltipDisabled]="disabledTooltip(this.havsRagStatus)">
        <mat-label i18n="@@type.MechanicalAspect.havsRagStatus">HAVS R/A/G Status</mat-label>
        <mat-select formControlName="havsRagStatus" id="havsRagStatus"              
            (ngModelChange)="havsRagStatusChanging($event)" [(ngModel)]="item.havsRagStatus"              
            (ngModelChange)="havsRagStatusChanged($event)" #havsRagStatus              
            placeholder="HAVS R/A/G Status">
          <mat-option>Any</mat-option>
          <mat-option *ngFor="let havsRagStatus of ragStatusSelectionList" [value]="havsRagStatus.code">
            {{havsRagStatus.meaning}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>

    <span>
      <span>
        <mat-slide-toggle floatLabel="always" appearance="none" color="primary"
            formControlName="wbv" id="wbv" matTooltip="WBV (Whole Body Vibration)"
            (ngModelChange)="wbvChanging($event)" [(ngModel)]="item.wbv"              
            (ngModelChange)="wbvChanged($event)" #wbv i18n="@@type.MechanicalAspect.wbv">
WBV          </mat-slide-toggle>        
      </span>
    </span>

    <span>
      <mat-form-field matTooltip="Select a Whole Body Vibration (WBV) Red/Amber/Green Status from the list" [matTooltipDisabled]="disabledTooltip(this.wbvRagStatus)">
        <mat-label i18n="@@type.MechanicalAspect.wbvRagStatus">WBV R/A/G Status</mat-label>
        <mat-select formControlName="wbvRagStatus" id="wbvRagStatus"              
            (ngModelChange)="wbvRagStatusChanging($event)" [(ngModel)]="item.wbvRagStatus"              
            (ngModelChange)="wbvRagStatusChanged($event)" #wbvRagStatus              
            placeholder="WBV R/A/G Status">
          <mat-option>Any</mat-option>
          <mat-option *ngFor="let wbvRagStatus of ragStatusSelectionList" [value]="wbvRagStatus.code">
            {{wbvRagStatus.meaning}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </span>

  </div>

</form>